import {Component, Inject, OnInit} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material";
import {AdditionalSettingsDialog} from "./additionalSettings.dialog";


@Component({
    selector: 'app-customer-view-dialog',
    templateUrl: 'customerView.dialog.html'
})

export class CustomerViewDialog implements OnInit {
    constructor(private http: HttpClient,
                public dialogRef: MatDialogRef<AdditionalSettingsDialog>,
                private dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: any){}

    items: any;
    loading: boolean;


    ngOnInit(){
        this.loading = true;
        this.http.get<any>('/api/delivery/items/?page=1&limit=999').subscribe(data => {
            this.items = data['docs'];
            this.loading = false;
        });
    }

    onSelectItem(item){
        let dialogRef = this.dialog.open(ItemSelectDialog, {
            data: {mainItem: item},
            width: '40%',
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result.added.concat(result.base.concat(result.variants)));
            let finalComposition: any = {};
            let selectedComposition = result.added.concat(result.base.concat(result.variants));
            finalComposition._id = result.baseId;
            finalComposition.name = item.name;
            finalComposition.price = item.price;
            finalComposition.imageUrl = item.imageUrl;
            finalComposition.composition = selectedComposition.filter(val => !result.removed.includes(val));
            console.log(finalComposition);
        });
    }

    closeDialog(){
        this.dialogRef.close();
    }

}


@Component({
    selector: 'app-item-select-dialog',
    templateUrl: './itemSelect.dialog.html'
})

export class ItemSelectDialog {
    // Method one
    quantity = 1;
    baseItemId: any = this.data.mainItem._id;

    // Iterations
    added = [];
    removed = [];
    variants = [];
    base = [];

    groups: any[] = [];
    selectedOption: any;
    selectedVariant = false;
    removablesList = [];

    constructor(public dialogRef: MatDialogRef<ItemSelectDialog>,
                @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit() {

        this.removablesList = this.data.mainItem.items.filter(item => {
            return item.items.length === 0 && item.min === 0 && item.default === 1;
        });
        this.groups = this.data.mainItem.items.filter(u => u.items.length > 0);
        for (let basic of this.data.mainItem.items) {
            if (basic.items.length === 0 && basic.default === 1) {
                this.base.push(basic);
            }
        }
    }


    addItem(item) {
        this.added.push(item);
    }


    addToRemovables(item) {
        if (!this.removed.includes(item)) {
            this.removed.push(item);
        } else {
            this.removed.splice(this.removed.findIndex(val => val === item), 1);
        }
    }

    checkQuantity(item) {
        let filtered = this.added.filter(x => x === item);
        return filtered.length;
    }

    removeItem(item) {
        this.added.splice(this.added.findIndex(x => x === item), 1);
    }

    confirmExtras() {
        let finalOrder = {base: this.baseItemId, added: this.added, removed: this.removed, variants: this.variants, quantity: this.quantity};
        this.dialogRef.close(finalOrder);
    }

    cancelExtras() {
        this.dialogRef.close(null);
    }

    selectVariant(item) {
        this.selectedOption = item;
        this.selectedVariant = true;
    }

    nextStep() {
        this.variants.push(this.selectedOption);
        this.selectedVariant = false;
    }

    setVariant(item) {
        this.variants.push(item._id);
    }

    addExtra(item) {
        this.added.push(item._id);
    }

    cancelBuy() {
        this.dialogRef.close(null);
    }

    confirmBuy() {
        let composedSell: any = {};
        composedSell.added = this.added;
        composedSell.removed = this.removed;
        composedSell.variants = this.variants;
        composedSell.baseId = this.baseItemId;
        composedSell.base = this.base;
        composedSell.name = this.data.mainItem.name;
        this.dialogRef.close(composedSell);
    }

    removeOptional(item) {
        this.removed.push(item._id);
    }
}


// WEBPACK FOOTER //
// ./src/app/delivery/components/dialogs/customerView.dialog.ts